export class CookieService {
  public setCookie(name: string, value: string, daysExpire = 1) {
    if (!checkCookie()) {
      return;
    }

    const ONE_DAY_MILLISECONDS = 86400000;
    const days = daysExpire;
    const expirationDate = new Date();

    expirationDate.setTime(+expirationDate + days * ONE_DAY_MILLISECONDS);

    document.cookie = `${name}=${value}; domain=${this.verifyDomain()}; expires=${expirationDate.toUTCString()}; path=/`;
  }

  public getCookie(name: string) {
    if (!checkCookie()) {
      return null;
    }

    const cookies = `; ${document.cookie}`;
    const cookieParts = cookies.split(`; ${name}=`);

    if (cookieParts.length === 2) {
      return cookieParts.pop()?.split(';').shift();
    }

    return null;
  }

  public removeCookie(name: string) {
    if (!checkCookie()) {
      return;
    }
    document.cookie = name + `=; domain=${this.verifyDomain()}; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }

  private verifyDomain() {
    const domain = window.location.host.split('.').slice(1).join('.');

    if (!domain) {
      return window.location.host.split(':')[0];
    }

    return `.${domain}`;
  }
}

export const checkCookie = () => {
  try {
    return !!navigator.cookieEnabled;
  } catch {
    return false;
  }
};

export const cookieService = new CookieService();
